module.exports = __webpack_public_path__ + "img/partner_20.b0eaf199.png";